import { formatLocalDateToUtc } from '@shared/libs/format-local-date';
import { convertUtcToLocal } from '@shared/libs/format-date';

export const EVENT_DAY_TIME_ERROR = 'Укажите часы (от 0 до 23) и минуты (от 0 до 59) отправки билетов';

export interface EventDaySendingTime {
  hour: number;
  minute: number;
}

// Оставляет в поле часов/минут только цифры, максимум 2 символа
export const sanitizeTimePart = (value: string): string => value.replace(/\D/g, '').slice(0, 2);

// Приводит значение к виду для инпута: 9 -> '09'
export const formatTimePart = (value: number | null | undefined): string =>
  value === null || value === undefined ? '' : String(value).padStart(2, '0');

// Разбирает введённые часы и минуты, null - если значение некорректно
export const parseEventDaySendingTime = (hour: string, minute: string): EventDaySendingTime | null => {
  if (!hour.length || !minute.length) {
    return null;
  }

  const parsedHour = Number(hour);
  const parsedMinute = Number(minute);

  if (!Number.isInteger(parsedHour) || !Number.isInteger(parsedMinute)) {
    return null;
  }

  if (parsedHour < 0 || parsedHour > 23 || parsedMinute < 0 || parsedMinute > 59) {
    return null;
  }

  return { hour: parsedHour, minute: parsedMinute };
};

// Собирает момент отправки для бэкенда: дата начала мероприятия + введённое
// время, сконвертированные в UTC — так же, как invitationExpiresAt и
// sendTicketAfterAcceptAt
export const buildEventDaySendingAt = (eventDateStart: string, time: EventDaySendingTime): string =>
  formatLocalDateToUtc(new Date(eventDateStart), `T${formatTimePart(time.hour)}:${formatTimePart(time.minute)}:00`);

// Разбирает сохранённый момент отправки (UTC) в часы и минуты локального
// времени для полей ввода
export const splitEventDaySendingAt = (sendingAt: string | null | undefined): { hour: string; minute: string } => {
  if (!sendingAt) {
    return { hour: '', minute: '' };
  }

  const local = convertUtcToLocal(sendingAt);

  return { hour: formatTimePart(local.getHours()), minute: formatTimePart(local.getMinutes()) };
};
